const LOGO_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_255e7e62-ccdf-42f6-90cc-f125b7c81d8a/artifacts/so4imw2c_Job%20Spring%20Logo.jpeg";

export function Brand({ dark = false, compact = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <div className="relative flex items-center">
        <span className={`font-heading font-extrabold tracking-tight whitespace-nowrap ${compact ? "text-lg" : "text-2xl"}`}>
          <span className={dark ? "text-white" : "text-[#0B1B3D]"}>JOB</span>{" "}
          <span className="text-[#2563EB]">SPRING</span>
        </span>
        <svg
          className={`${compact ? "w-4 h-4" : "w-5 h-5"} -ml-0.5 mb-3 text-[#F5A623]`}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M7 17L17 7" />
          <path d="M8 7h9v9" />
        </svg>
      </div>
    </div>
  );
}

export { LOGO_URL };
